import React, { useEffect } from "react";
import { func, string, object } from "prop-types";
import { Card, Col, Row, Button } from "react-bootstrap";
import notificationIcon from "../../resources/images/notification-blue-green-2x.png";
import whiteRightArrow from "../../resources/images/arrow-right-white.png";

const NewFeatureNotificationModal = ({
  dismissNotification,
  cardClassName,
  notificationContent,
  notificationTitle,
  navigateToAssessmentSettings,
  modalName,
}) => {
  useEffect(() => {
    window.analytics.track("modal viewed", {
      "modal name": modalName,
    });
  }, []);

  const onDismissNotification = () => {
    window.analytics.track("modal closed", {
      "modal name": modalName,
    });
    dismissNotification();
  };
  return (
    <Card className={cardClassName}>
      <Card.Body>
        <Row>
          <Col lg={1} className="m-auto">
            <img
              src={notificationIcon}
              height="16px"
              width="16px"
              alt="bell notification icon"
            />
          </Col>
          <Col lg={11}>
            <span style={{ fontWeight: "bold", fontSize: "16px" }}>
              {notificationTitle}
            </span>
          </Col>
        </Row>
        <Row>
          <Col>{notificationContent}</Col>
        </Row>
        <Row className="text-right">
          <Col>
            <button
              type="button"
              className="btn-as-link mr-2"
              style={{
                color: "#425cc7",
                fontWeight: "bold",
                textDecoration: "none",
              }}
              onClick={onDismissNotification}
            >
              Dismiss
            </button>
            {modalName === "work factors notification" ? (
              <Button
                variant="primary"
                className="btn-card-table-header"
                value="/workFactors_form"
                onClick={navigateToAssessmentSettings}
                id="createWorkFactors"
              >
                Go to Assessment Settings
                <span>
                  <img
                    height="16px"
                    width="16px"
                    src={whiteRightArrow}
                    alt="plus"
                    className="ml-2 mb-1"
                  ></img>
                </span>
              </Button>
            ) : null}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

NewFeatureNotificationModal.propTypes = {
  cardClassName: string,
  dismissNotification: func.isRequired,
  navigateToAssessmentSettings: func,
  notificationContent: object,
  notificationTitle: string,
  modalName: string,
};

export default NewFeatureNotificationModal;
